//List des API_KEY achetés
export const API_KEY_LIST_REQUESTING = 'API_KEY_LIST_REQUESTING'
export const API_KEY_LIST_SUCCESS = 'API_KEY_LIST_SUCCESS'
export const API_KEY_LIST_FAILED = 'API_KEY_LIST_FAILED'

export const PAGINATE_API_KEY_LIST_REQUESTING = 'PAGINATE_API_KEY_LIST_REQUESTING'
export const PAGINATE_API_KEY_LIST_SUCCESS = 'PAGINATE_API_KEY_LIST_SUCCESS'
export const PAGINATE_API_KEY_LIST_FAILED = 'PAGINATE_API_KEY_LIST_FAILED'

